export interface Video {
  id: string;
  title: string;
  thumbnail: string;
  category: string;
  duration: string;
  views: number;
  date: string;
  description: string;
  tags: string[];
  featured?: boolean;
  quality: string;
}

export const videos: Video[] = [
  {
    id: 'v1',
    title: '2024年度最受欢迎影视作品大盘点',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20theater%20scene%20with%20warm%20golden%20lighting%2C%20film%20reel%20and%20popcorn%2C%20dark%20theater%20background%2C%20professional%20photography%2C%20atmospheric%20mood&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    category: 'hongtao',
    duration: '1:28:45',
    views: 128500,
    date: '2026-07-28',
    description: '回顾2024年最受观众喜爱的影视作品，涵盖动作、爱情、喜剧等多种类型，高清画质带来极致观影体验。',
    tags: ['影视', '大盘点', '年度'],
    featured: true,
    quality: '4K',
  },
  {
    id: 'v2',
    title: '全网热播综艺：明星大咖欢乐对决',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20bright%20colorful%20variety%20show%20stage%20with%20spotlights%2C%20cheerful%20atmosphere%2C%20studio%20setting%20with%20warm%20tones%2C%20entertainment%20theme&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    category: 'mangguo',
    duration: '2:05:30',
    views: 256800,
    date: '2026-07-27',
    description: '当红明星齐聚一堂，欢乐游戏对决，爆笑不断。芒果视频独家播出，高清画质流畅不卡顿。',
    tags: ['综艺', '明星', '搞笑'],
    featured: true,
    quality: '1080P',
  },
  {
    id: 'v3',
    title: '悬疑大片：迷雾追踪终极真相',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20mysterious%20foggy%20street%20scene%20at%20night%20with%20warm%20streetlamp%20light%2C%20suspenseful%20atmosphere%2C%20detective%20theme%2C%20cinematic%20photography%2C%20noir%20style&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    category: 'xiaolan',
    duration: '1:52:18',
    views: 189200,
    date: '2026-07-26',
    description: '一桩离奇案件背后的惊人真相，紧张刺激的悬疑剧情让你欲罢不能，小蓝视频高清呈现。',
    tags: ['悬疑', '大片', '剧情'],
    quality: '4K',
  },
  {
    id: 'v4',
    title: '治愈系美食纪录片：寻味中国',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20cuisine%20spread%20on%20a%20wooden%20table%20with%20warm%20natural%20lighting%2C%20steaming%20dishes%2C%20rustic%20kitchen%20background%2C%20food%20documentary%20style&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    category: 'xigua',
    duration: '3:15:00',
    views: 312000,
    date: '2026-07-25',
    description: '走遍大江南北，探寻最地道的美食文化，温暖人心的美食故事，西瓜视频精品纪录片系列。',
    tags: ['美食', '纪录片', '文化'],
    featured: true,
    quality: '4K',
  },
  {
    id: 'v5',
    title: '动作巨制：极限追捕无路可逃',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20intense%20action%20scene%20with%20cars%20on%20a%20highway%20at%20sunset%2C%20dramatic%20orange%20sky%2C%20cinematic%20photography%2C%20adrenaline%20fueled%20atmosphere&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    category: 'qiezi',
    duration: '2:08:22',
    views: 445600,
    date: '2026-07-24',
    description: '国际动作巨星联袂出演，震撼的爆破场面和精彩打斗，茄子视频高清全集放送。',
    tags: ['动作', '大片', '刺激'],
    quality: '1080P',
  },
  {
    id: 'v6',
    title: '都市情感剧：爱情的温度刚刚好',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20romantic%20city%20scene%20at%20sunset%20with%20a%20couple%20walking%2C%20soft%20warm%20lighting%2C%20modern%20urban%20backdrop%2C%20emotional%20atmosphere%2C%20drama%20style&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    category: 'hongtao',
    duration: '45:30',
    views: 98700,
    date: '2026-07-23',
    description: '都市男女的爱情故事，温暖治愈的剧情让人心动不已，红桃视频独家热播中。',
    tags: ['爱情', '都市', '情感'],
    quality: '1080P',
  },
  {
    id: 'v7',
    title: '科幻巨作：星际穿越新纪元',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20futuristic%20spaceship%20interior%20with%20blue%20and%20orange%20glowing%20lights%2C%20sci-fi%20atmosphere%2C%20space%20theme%2C%20cinematic%20quality%2C%20epic%20scale&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    category: 'jiujiu',
    duration: '2:35:10',
    views: 523100,
    date: '2026-07-22',
    description: '人类探索未知星系的壮丽史诗，震撼的视觉特效和深刻的剧情，久久视频经典收藏。',
    tags: ['科幻', '巨作', '视觉'],
    featured: true,
    quality: '4K',
  },
  {
    id: 'v8',
    title: '爆笑喜剧：办公室那些事儿第二季',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20funny%20modern%20office%20scene%20with%20colorful%20decor%2C%20people%20laughing%2C%20bright%20natural%20lighting%2C%20comedy%20sitcom%20style%2C%20cheerful%20workspace&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    category: 'mangguo',
    duration: '30:20',
    views: 167400,
    date: '2026-07-21',
    description: '办公室日常中的爆笑故事，轻松幽默让你捧腹大笑，芒果视频欢乐上线。',
    tags: ['喜剧', '办公室', '搞笑'],
    quality: '1080P',
  },
  {
    id: 'v9',
    title: '恐怖惊悚：午夜凶宅实录',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dark%20creepy%20old%20house%20interior%20with%20moonlight%20through%20windows%2C%20mysterious%20shadows%2C%20horror%20atmosphere%2C%20cinematic%20photography%2C%20tense%20mood&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    category: 'xiaolan',
    duration: '1:45:55',
    views: 278300,
    date: '2026-07-20',
    description: '真实灵异事件改编，令人毛骨悚然的恐怖体验，胆小者慎入，小蓝视频勇敢者挑战。',
    tags: ['恐怖', '惊悚', '灵异'],
    quality: '1080P',
  },
  {
    id: 'v10',
    title: '热血动漫：龙族崛起最终章',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20epic%20anime%20style%20dragon%20flying%20over%20a%20fantasy%20castle%20at%20sunset%2C%20vibrant%20colors%2C%20dramatic%20clouds%2C%20adventure%20theme%2C%20cinematic&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    category: 'qiezi',
    duration: '24:00',
    views: 634200,
    date: '2026-07-19',
    description: '少年与巨龙的史诗冒险迎来最终篇章，精美画面热血剧情，茄子视频动漫频道热播。',
    tags: ['动漫', '热血', '冒险'],
    quality: '4K',
  },
  {
    id: 'v11',
    title: '自然风光纪录片：极地奇迹',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20stunning%20arctic%20landscape%20with%20northern%20lights%20and%20snow%20covered%20mountains%2C%20pristine%20nature%2C%20documentary%20photography%2C%20breathtaking%20scenery&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    category: 'xigua',
    duration: '1:30:00',
    views: 145600,
    date: '2026-07-18',
    description: '探索地球最极端的自然环境，罕见的高清画面记录极地生物的生存奇迹。',
    tags: ['自然', '纪录片', '极地'],
    quality: '4K',
  },
  {
    id: 'v12',
    title: '经典港片回顾：无间风云三十年',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20Hong%20Kong%20street%20scene%20with%20neon%20signs%20at%20night%2C%20rainy%20mood%2C%20film%20noir%20style%2C%20classic%20cinema%20aesthetic%2C%20warm%20tones&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    category: 'jiujiu',
    duration: '2:12:35',
    views: 389000,
    date: '2026-07-17',
    description: '重温港片黄金时代的经典作品，那些年我们追过的港片记忆，久久视频经典重现。',
    tags: ['港片', '经典', '怀旧'],
    quality: '1080P',
  },
];

export function getVideosByCategory(slug: string): Video[] {
  return videos.filter((v) => v.category === slug);
}

export function getVideoById(id: string): Video | undefined {
  return videos.find((v) => v.id === id);
}

export function getFeaturedVideos(): Video[] {
  return videos.filter((v) => v.featured);
}

export function getLatestVideos(limit: number = 8): Video[] {
  return [...videos].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
}

export function getPopularVideos(limit: number = 6): Video[] {
  return [...videos].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getRelatedVideos(currentId: string, limit: number = 4): Video[] {
  return videos.filter((v) => v.id !== currentId).slice(0, limit);
}